import { useDocumentTitle } from "../hooks/shared/useDocumentTitle";

/**
 * Component that updates the document title based on the current route.
 * Must be rendered inside the Portal/I18nProvider context.
 */
export function DocumentTitleUpdater() {
  useDocumentTitle();
  return null;
}
